import React from 'react'

import {
  AlignItems,
  Box,
  Button,
  ButtonColorVariant,
  Color,
  Display,
  FontWeight,
  Overflow,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

const EditButton = withCitrusTheme(Button, (theme) => ({
  '&&': {
    fontSize: theme.tokens.fontSizes[2].fontSize,
    lineHeight: theme.tokens.fontSizes[2].lineHeight,
    padding: theme.spacing(3),
  },

  '&&:not(:disabled):focus:not(:focus-visible)': {
    backgroundColor: theme.color(Color.Transparent),
    borderColor: theme.color(Color.Transparent),
    borderWidth: 0,
    boxShadow: 'none',
    color: theme.color(Color.Secondary_400),
    outline: 'none',
  },

  '&&:not(:disabled):active:not(:focus-visible)': {
    backgroundColor: theme.color(Color.Transparent),
    borderColor: theme.color(Color.Transparent),
    borderWidth: 0,
    boxShadow: 'none',
    color: theme.color(Color.Secondary_500),
    outline: 'none',
  },

  '&&:not(:disabled):hover:not(:focus-visible)': {
    backgroundColor: theme.color(Color.Transparent),
    borderColor: theme.color(Color.Transparent),
    borderWidth: 0,
    boxShadow: 'none',
    color: theme.color(Color.Secondary_500),
    outline: 'none',
  },
}))

type FlexPortionIndicatorProps = {
  recipeCount: number
  portionCount: number
  onEdit: () => void
}

export const FlexPortionIndicator = ({
  recipeCount,
  portionCount,
  onEdit,
}: FlexPortionIndicatorProps) => {
  return (
    <Box
      alignItems={AlignItems.Center}
      bg={Color.White}
      boxShadow="0 1px 5px 0 rgba(51, 61, 71, 0.2)"
      data-testid="flex-portion-indicator"
      display={Display.InlineFlex}
      maxWidth="100%"
      minHeight="44px"
      overflowX={Overflow.Hidden}
      overflowY={Overflow.Hidden}
      style={{ borderRadius: '4px' }}
    >
      <Box alignItems={AlignItems.Center} display={Display.Flex} gap={2} paddingH={3}>
        <Text size={2} fontWeight={FontWeight.Bold} color={Color.ColdGrey_800}>
          {`${recipeCount} ${recipeCount === 1 ? 'recipe' : 'recipes'}`}
        </Text>
        <Text size={2} fontWeight={FontWeight.Bold} color={Color.ColdGrey_800}>
          •
        </Text>
        <Text size={2} fontWeight={FontWeight.Bold} color={Color.ColdGrey_800}>
          {`${portionCount} ${portionCount === 1 ? 'portion' : 'portions'}`}
        </Text>
      </Box>
      <EditButton
        aria-label="Edit number of portions"
        colorVariant={ButtonColorVariant.Tertiary}
        onKeyDown={(event: React.KeyboardEvent) => {
          event.stopPropagation()
        }}
        onKeyPress={(event: React.KeyboardEvent) => {
          event.stopPropagation()
        }}
        onKeyUp={(event: React.KeyboardEvent) => {
          event.stopPropagation()
        }}
        onMouseDown={(event: React.MouseEvent) => {
          event.preventDefault()
        }}
        onClick={(event: React.MouseEvent) => {
          event.stopPropagation()
          onEdit()
        }}
      >
        Edit
      </EditButton>
    </Box>
  )
}
